import React from 'react';
import WaitCube from '../../WaitCube.js'
import $ from "jquery";
import {_GPY,__GPYPost} from '../../env.js'
import GpyFileUpload from '../gametypes/lib/GpyFileUpload.js'

class Advertisement extends React.Component {
  constructor(props) {
   super(props);
   this.state = {
     currentAdvertisement: {id:-1,name:""},
     unsave: false,
     advertisementsIsLoaded : false,
     advertisements : {},
     usageType: this.props.usageType!==undefined?this.props.usageType:"ADVERTISING",
   };
  }

  onFileUpload(file) {
 	 var obj = this.state.currentAdvertisement;
 	 obj.image = file;
 	 this.setState({currentAdvertisement:obj,unsave: true,});
  }

  componentDidMount(){
    console.log(this.props);
    this.getAdvertisements();
  }

  onChange(key,e) {
    var o = this.state.currentAdvertisement;
    o[key] = e.target.value;
    this.setState({currentAdvertisement:o,unsave:true});
  }

  getAdvertisements() {
    __GPYPost('getAdvertisements',{usageType:this.state.usageType},(res)=>{
      this.setState({
        advertisementsIsLoaded: true,
        advertisements: res,
      });
    },(err)=>{
      this.setState({
        advertisementsIsLoaded: false,
      });
    });
	}

  createOrUpdateAdvertisement(){
     var ca = this.state.currentAdvertisement;
     ca.usageType = this.state.usageType;

    __GPYPost('createOrUpdateAdvertisement',ca,(res)=>{
      this.setState({
        ounsave: false,
      });
      this.getAdvertisements();
    });
  }

  onSelectAdvertisement(o) {
        this.setState({currentAdvertisement:_GPY.cloneObj(o), unsave: false});
  }

  onNewAdvertisement(f){
    this.setState({ currentAdvertisement: {id:-1,name:""}});
     $('#outputFormat').focus();
  }

  deleteAdvertisement(){
    var ca = this.state.currentAdvertisement;
    ca.usageType = this.state.usageType;
    __GPYPost('deleteAdvertisement',ca,(res)=>{
      this.setState({
        unsave: false,
      });
      this.getAdvertisements();
      this.onNewAdvertisement();
    });
  }

	render() {
    var isUnsave = (unsave ,prefix) => {
        if(unsave && _GPY.isMin2(this.state.currentAdvertisement.name)){
          return prefix + "success";
        } else {
          return prefix + "primary disabled";
        }
    }
    /*
    var isUpdate = (current, prefix) => {
        if(current.id>0){
          return prefix + "danger";
        } else {
          return prefix + "danger disabled";
        }
    }
   */
    return (
      <div>
        <div className="row">
          <div className="col-12 col-lg-3 col-xl-3">

              <div className="row pt-2">
                  <div className="col-8"><h3>{_GPY.i18n.get('advertisement_'+this.state.usageType+'_list_headline')}</h3></div>
                  <div className="col-4 text-right align-bottom"><button type="button" onClick={this.onNewAdvertisement.bind(this)} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button></div>
               </div>

               <div className="row">
                  <div className="col">
                     <div className="list-group">
                        {this.state.advertisementsIsLoaded ? this.state.advertisements.Advertisements.Advertisement.map((t) =>
                          <button key={t.id} onClick={this.onSelectAdvertisement.bind(this,t)} className={t.id === this.state.currentAdvertisement.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
                             <div className="d-flex w-100 justify-content-between">
                               <small className="ml-3">{t.name}</small>
                               <img style={{maxWidth : '100px', maxHeight: '100px'}} src={t.image!==undefined&&t.image!==""?_GPY.resource("/upload/" + t.image):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt={this.state.usageType}/>
                             </div>
                          </button>
                        ) :  <WaitCube/>  }
                     </div>
                   </div>
               </div>

          </div>
          <div className="col-12 col-lg-9 col-xl-9 pt-2">

                  <div className="card bg-light">
                      <div className="card-header">Output Display</div>
                      <div className="row p-3">
                          <div className="col-12 col-md-6  mb-1">
                          	<label htmlFor="gameName">{_GPY.i18n.get('advertisement_'+this.state.usageType+'_list_headline_box_form_input_name_title')}</label>
                            <input onChange={this.onChange.bind(this,"name")} value={this.state.currentAdvertisement.name} name="gameName" type="text"  className="form-control" placeholder={_GPY.i18n.get('advertisement_'+this.state.usageType+'_list_headline_box_form_input_name_placeholder')}/>
                        </div>
                        <div className="col-12 col-md-6  mb-1">
                          <img style={{maxWidth : '300px', maxHeight: '300px'}} src={this.state.currentAdvertisement.image!==undefined&&this.state.currentAdvertisement.image!==""?_GPY.resource("upload/" + this.state.currentAdvertisement.image):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt={this.state.usageType}/>
                      </div>
                        <div className="col-12  mb-1">
	                           <GpyFileUpload title={_GPY.i18n.get('advertisement_'+this.state.usageType+'_list_headline_box_form_input_upload_title')} className="btn btn-secondary mr-2" callBack={this.onFileUpload.bind(this)}/>
                             <span className="text-muted">{_GPY.i18n.get('advertisement_'+this.state.usageType+'_list_headline_box_form_input_upload_info')}</span>
                        </div>


                </div>


                      <div className="row pl-3 pr-3">
                          <div className="col-12 border-bottom"></div>
                      </div>

                      <div className="row justify-content-end p-3">
                          <div className="col-3 col-md-2 col-lg-2 text-right">
                          <button className={isUnsave(this.state.unsave,"btn btn-")} onClick={this.createOrUpdateAdvertisement.bind(this)}><span className={this.state.currentAdvertisement.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
                          <button type="button" className={this.state.currentAdvertisement.id>0?"ml-2 btn btn-danger":"ml-2 btn btn-danger disabled"} onClick={this.deleteAdvertisement.bind(this)}><span className="glyphicon glyphicon-remove"/></button>
                          </div>
                      </div>

                  </div>
            </div>
          </div>

      </div>
		 	);
    }
}
export default Advertisement;
